import { render, staticRenderFns } from "./IssuesSearchBlock.vue?vue&type=template&id=6d4ac135&"
import script from "./IssuesSearchBlock.vue?vue&type=script&lang=js&"
export * from "./IssuesSearchBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports